import { cn } from "helpers/classNames";
import React, { FC } from "react";
interface Props {
  children: React.ReactNode;
}
export const Table: FC<
  Props &
    React.DetailedHTMLProps<
      React.TableHTMLAttributes<HTMLTableElement>,
      HTMLTableElement
    >
> = ({ children, className, ...rest }) => (
  <div className={cn("flex flex-col", className)}>
    <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-1">
      <div className="inline-block min-w-full py-2 align-middle md:px-1">
        <div className="overflow-hidden shadow ring-1 ring-gray-100 ring-opacity-100 md:rounded-lg">
          <table {...rest} className="min-w-full divide-y divide-gray-300">
            {children}
          </table>
        </div>
      </div>
    </div>
  </div>
);
